import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconMoreVert = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
  </SvgIcon>
);

export default IconMoreVert;



// WEBPACK FOOTER //
// ./src/components/icons/IconMoreVert.js